class CartReviewQuote extends HTMLElement {
  connectedCallback() {
    this.inner = this.querySelector('.cart-review-quote__inner');
    this.reviews = Array.from(this.querySelectorAll('.cart-review-quote__review'));
    if (!this.inner || this.reviews.length < 2) return;

    const visibleIndex = this.reviews.findIndex((review) => !review.hidden);
    this.index = visibleIndex === -1 ? 0 : visibleIndex;

    const intervalSeconds = Number.parseInt(this.dataset.rotationInterval, 10);
    const intervalMs = (Number.isNaN(intervalSeconds) ? 10 : intervalSeconds) * 1000;
    this.timer = window.setInterval(() => this.rotate(), intervalMs);
  }

  disconnectedCallback() {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  }

  // 0 when prefers-reduced-motion sets transition: none — rotation then swaps instantly.
  getFadeDuration() {
    const duration = window.getComputedStyle(this.inner).transitionDuration;
    return Number.parseFloat(duration) * 1000 || 0;
  }

  showNext() {
    this.reviews[this.index].hidden = true;
    this.index = (this.index + 1) % this.reviews.length;
    this.reviews[this.index].hidden = false;
    // The card scrolls internally when capped (see CSS); start each review from the top.
    this.scrollTop = 0;
  }

  rotate() {
    const fadeDuration = this.getFadeDuration();
    if (fadeDuration === 0) {
      this.showNext();
      return;
    }

    this.inner.classList.add('is-fading');
    window.setTimeout(() => {
      this.showNext();
      // Forced reflow (instead of requestAnimationFrame, which is suppressed in
      // hidden/occluded windows) so the swapped content still transitions back in.
      void this.inner.offsetHeight;
      this.inner.classList.remove('is-fading');
    }, fadeDuration);
  }
}

if (!customElements.get('cart-review-quote')) {
  customElements.define('cart-review-quote', CartReviewQuote);
}
